import React from 'react';
import i18next from 'i18next';
import { toast } from 'react-toastify';
import IconToast from 'assets/icons/IconToast';
import ToastContent from './ToastContent';

export const getText = (key, fallback, values) => {
    if (key) return i18next.t(key, values)
    return fallback || ''
}

export function showToast({
    type,
    title,
    text,
    titleKey,
    textKey,
    values,
    options
}) {
    const titleText = getText(titleKey, title, values)
    const bodyText = getText(textKey, text, values)

    toast[type](<ToastContent title={titleText} text={bodyText} type={type} />, {
        ...options,
        icon: <IconToast type={type} />
    })
}
